import LocalizedLink from '../LocalizedLink';

const variants = {
  primary: 'bg-blue-600 text-white shadow-lg hover:bg-blue-700 hover:shadow-xl rounded-lg',
  outline:
    'text-white shadow-lg hover:bg-white/10 hover:border-white hover:shadow-xl rounded-full border border-white/80',
  navPrimary: 'bg-blue-600 text-white hover:bg-blue-700 rounded-lg',
};

const sizes = {
  lg: 'px-12 py-5 text-xl',
  md: 'px-10 py-4 text-lg',
  sm: 'px-2 py-1.5 text-sm font-medium lg:px-2.5 lg:py-2 xl:px-4',
};

const LocalizedButton = ({ to, name, variant = 'primary', size = 'lg', className = '' }) => {
  return (
    <LocalizedLink
      to={to}
      className={`inline-block w-fit font-semibold transition-colors ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {name}
    </LocalizedLink>
  );
};

export default LocalizedButton;
